import { Box, Typography, Skeleton } from '@mui/material';
import '@fontsource/rubik';

function ContractRow({ label, value, isLoading }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: '9px',
        borderTop: '1px solid rgba(244,244,241,0.1)',
        '&:first-of-type': { borderTop: 'none', pt: '4px' },
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Rubik',
          fontSize: { xs: '11px', lg: '12px', xl: '13px' },
          color: 'rgba(244,244,241,0.7)',
        }}
      >
        {label}
      </Typography>
      {isLoading ? (
        <Skeleton
          width={60}
          height={16}
          sx={{ backgroundColor: 'rgba(244,244,241,0.1)', borderRadius: '4px' }}
        />
      ) : (
        <Typography
          sx={{
            fontFamily: 'Rubik',
            fontSize: { xs: '11px', lg: '12px', xl: '13px' },
            fontWeight: 600,
            color: 'rgba(244,244,241,0.95)',
          }}
        >
          {value}
        </Typography>
      )}
    </Box>
  );
}

export default function ContractSidebar({ summary, isLoading }) {
  const contractType = summary?.contract_type || 'NA';
  const contractStart = summary?.contract_start || 'NA';
  const contractEnd = summary?.contract_end || 'NA';
  const creditBased = summary?.credit_based ?? false;
  const videosTotal = creditBased ? (summary?.credits_total ?? 'NA') : (summary?.videos_total ?? 'NA');
  const revisionsPerVideo = summary?.revisions_per_video ?? 'NA';
  const qtTotal = summary?.quick_turns_total ?? 'NA';
  const videoLengthMins = summary?.video_length_mins;

  return (
    <Box
      sx={{
        backgroundColor: '#08231B',
        color: '#f4f4f1',
        borderRadius: '14px',
        p: '18px 20px 16px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Contract tag */}
      <Box
        sx={{
          display: 'inline-block',
          backgroundColor: '#00d744',
          color: '#08231B',
          fontSize: { xs: '9px', lg: '10px' },
          fontWeight: 700,
          letterSpacing: '0.14em',
          fontFamily: 'Rubik',
          borderRadius: '4px',
          px: '7px',
          py: '3px',
          mb: 1.5,
          textTransform: 'uppercase',
        }}
      >
        Contract
      </Box>

      <Typography
        sx={{
          fontFamily: 'Rubik',
          fontSize: { xs: '16px', lg: '18px', xl: '20px' },
          fontWeight: 700,
          letterSpacing: '-0.01em',
          color: '#f4f4f1',
          mb: 0.5,
        }}
      >
        {isLoading ? <Skeleton width={180} sx={{ backgroundColor: 'rgba(244,244,241,0.1)' }} /> : contractType}
      </Typography>

      <Typography
        sx={{
          fontFamily: 'Rubik',
          fontSize: { xs: '11px', lg: '12px' },
          color: 'rgba(244,244,241,0.6)',
          mb: 2,
        }}
      >
        {isLoading ? (
          <Skeleton width={140} sx={{ backgroundColor: 'rgba(244,244,241,0.08)' }} />
        ) : (
          `${contractStart} – ${contractEnd}`
        )}
      </Typography>

      {/* Contract rows */}
      <ContractRow label={creditBased ? 'Video Credits' : 'Videos'} value={videosTotal} isLoading={isLoading} />
      <ContractRow label="Revisions / video" value={revisionsPerVideo} isLoading={isLoading} />
      <ContractRow label="24-hr Quick Turns" value={qtTotal} isLoading={isLoading} />
      {creditBased && videoLengthMins != null && (
        <Box sx={{ pt: '10px', borderTop: '1px solid rgba(244,244,241,0.1)' }}>
          <Typography
            sx={{
              fontFamily: 'Rubik',
              fontSize: { xs: '11px', lg: '12px', xl: '13px' },
              color: 'rgba(244,244,241,0.55)',
              fontStyle: 'italic',
            }}
          >
            {`1 credit equals up to ${videoLengthMins} mins of edited video`}
          </Typography>
        </Box>
      )}

    </Box>
  );
}
